const NotFound = () => {
    return(
        <div className="d-flex justify-content-center align-items-center" style={{height: '80vh'}}>
          <h2>Page Not Found</h2>
        </div>
    )
}

export default NotFound;